import { addReducer } from 'reactn'
import { IGlobalState, InEditingMode, InEditingCompany, EditStatus } from "./GlobalState"
import { Dispatch, State } from 'reactn/default'
import apiService from "../services/api"
import { Company } from '../models/company'
import { Agency } from '../models/agency'
import agencyFunctions from '../core/agency/agencyFunctions';
import { Principal } from '../models/principal'
import { WhatsNew } from '../models/whatsNew'

const setCurrentEditCompanyAndMode = (global: IGlobalState, dispatch: Dispatch, company: Company, mode: EditStatus) => {
    const currentEditCompany = { company, modified: false, mode: InEditingMode.Edit };
    const currentEditCompanyStatus = mode;
    return { currentEditCompany, currentEditCompanyStatus }
}

const createNewCompany = (global: IGlobalState, dispatch: Dispatch, newOid: number) => {
    console.log('Aggiungo company nel reducers di Reactn');
    const company: Company = Company.newItem();
    const currentEditCompany = { company, modified: true, mode: InEditingMode.New };
    const newCompanyOid = company.Id;
    return { currentEditCompany, newCompanyOid }
}

const companySaved = (global: IGlobalState, dispatch: Dispatch, company: Company) => {
    console.log('sono in Company Saved');
    const currentEditCompany = {company: company, modified: false, mode: InEditingMode.Edit }
    // const currentEditCompany = global.currentEditCompany;
    // const iec = inEditCompanies.find(x => x.company.Id === company.Id)
    /*
    if (iec) {
        iec.company = company;
        iec.modified = false;
        iec.mode = InEditingMode.Edit;
    }
    */
    const c = global.filteredCompanies.find(x => x.Id === company.Id)
    if (c) {
        c.BusinessName = company.BusinessName
        c.VatNumber = company.VatNumber
        c.TaxCode = company.TaxCode
        c.UiLogoUrl = company.UiLogoUrl
        // u.isLocked = company.isLocked
    }    
    // const companies = global.companies;
    const filteredCompanies = global.filteredCompanies;
    const currentEditCompanyStatus: EditStatus = 'Pristine';
    return { currentEditCompany, currentEditCompanyStatus, filteredCompanies }
}

const newCompanySaved = (global: IGlobalState, dispatch: Dispatch, temporaryId: number, company: Company) => {
    // Questo reducer viene chiamato quando è stato salvato un'applicazione nuova
    const currentEditCompany = { company: company, modified: false, mode: InEditingMode.Edit };
    const currentEditCompanyStatus: EditStatus = 'Pristine';
    // const users = global.users.filter(u => u.oid !== temporaryOid)
    const filteredCompanies = [...global.filteredCompanies, company]
    return { currentEditCompany, currentEditCompanyStatus, filteredCompanies }
}

const removeInEditCompany = (global: IGlobalState, dispatch: Dispatch, id: number) => {
    // Dobbiamo spazzare via l'utente da tutte le liste e da currentUser
    const companies = global.companies.filter(u => u.Id !== id)
    const filteredCompanies = global.filteredCompanies.filter(u => u.Id !== id)
    // const inEditUsers = global.inEditUsers.filter(u => u.principal.oid !== oid)
    if (global.currentEditCompany && global.currentEditCompany.company.Id === id) {
        return { companies, filteredCompanies, currentEditCompany: null }
    }
    return { companies, filteredCompanies }
}

// Agency
const setCurrentEditAgencyAndMode = (global: IGlobalState, dispatch: Dispatch, agency: Agency, mode: EditStatus) => {
    const currentEditAgency = { agency, modified: false, mode: InEditingMode.Edit };
    const currentEditAgencyStatus = mode;
    return { currentEditAgency, currentEditAgencyStatus }
}

const createNewAgency = (global: IGlobalState, dispatch: Dispatch, newOid: number) => {
    // const agency: Agency = agencyFunctions.newInEditAgency(0);
    const agency: Agency = Agency.newItem();
    const currentEditAgency = { agency, modified: true, mode: InEditingMode.New };
    const newAgencyOid = agency.Id;
    return { currentEditAgency, newAgencyOid }
}

const agencySaved = (global: IGlobalState, dispatch: Dispatch, agency: Agency) => {
    console.log('sono in Agency Saved');
    const currentEditAgency = {agency: agency, modified: false, mode: InEditingMode.Edit }
    const c = global.filteredAgencies.find(x => x.Id === agency.Id)
    if (c) {
        c.Name = agency.Name
        c.VatNumber = agency.VatNumber
        c.Address = agency.Address
        c.Code = agency.Code
        c.CityCode = agency.CityCode
        c.ProvinceCode = agency.ProvinceCode
        c.Disabled = agency.Disabled
        c.CompanyId = agency.CompanyId;
        c.PrincipalCounter = agency.PrincipalCounter;
        c.Id = agency.Id;
        c.State = agency.State;        
    }    
    // const companies = global.companies;
    const filteredAgencies = global.filteredAgencies;
    const currentEditAgencyStatus: EditStatus = 'Pristine';
    return { currentEditAgency, currentEditAgencyStatus, filteredAgencies }
}

const newAgencySaved = (global: IGlobalState, dispatch: Dispatch, temporaryId: number, agency: Agency) => {
    // Questo reducer viene chiamato quando è stato salvato un'applicazione nuova
    const currentEditAgency = { agency: agency, modified: false, mode: InEditingMode.Edit };
    const currentEditAgencyStatus: EditStatus = 'Pristine';
    const filteredAgencies = [...global.filteredAgencies, agency]
    return { currentEditAgency, currentEditAgencyStatus, filteredAgencies }
}

const removeInEditAgency = (global: IGlobalState, dispatch: Dispatch, id: number) => {
    // Dobbiamo spazzare via l'utente da tutte le liste e da currentUser
    const agencies = global.agencies.filter(u => u.Id !== id)
    const filteredAgencies = global.filteredAgencies.filter(u => u.Id !== id)
    // const inEditUsers = global.inEditUsers.filter(u => u.principal.oid !== oid)
    if (global.currentEditAgency && global.currentEditAgency.agency.Id === id) {
        return { agencies, filteredAgencies, currentEditAgency: null }
    }
    return { agencies, filteredAgencies }
}


// Principal
const setCurrentEditPrincipalAndMode = (global: IGlobalState, dispatch: Dispatch, principal: Principal, mode: EditStatus) => {
    const currentEditPrincipal = { principal, modified: false, mode: InEditingMode.Edit };
    const currentEditPrincipalStatus = mode;
    return { currentEditPrincipal, currentEditPrincipalStatus }
}

const createNewPrincipal = (global: IGlobalState, dispatch: Dispatch, newOid: number, companyId: number) => {
    // const agency: Agency = agencyFunctions.newInEditAgency(0);
    const principal: Principal = Principal.newItem(companyId);
    const currentEditPrincipal = { principal, modified: true, mode: InEditingMode.New };
    const newPrincipalOid = principal.Id;
    return { currentEditPrincipal, newPrincipalOid }
}

const principalSaved = (global: IGlobalState, dispatch: Dispatch, principal: Principal) => {
    const currentEditPrincipal = {principal: principal, modified: false, mode: InEditingMode.Edit }
    const c = global.filteredPrincipals.find(x => x.Id === principal.Id)
    if (c) {
        c.Name = principal.Name;
        c.Taxcode = principal.Taxcode;
        c.Mail = principal.Mail;
        c.Phone = principal.Phone;
        c.Surname = principal.Surname;
        c.Username = principal.Username;
        c.Disabled = principal.Disabled;
        c.CompanyId = principal.CompanyId;
        c.UserCreation = principal.UserCreation;
        c.Id = principal.Id;
        c.ApplicationBudget = principal.ApplicationBudget;
        c.ApplicationConvenienza = principal.ApplicationConvenienza;
        c.ApplicationForfetari = principal.ApplicationForfetari;

    }    
    // const companies = global.companies;
    const filteredPrincipals = global.filteredPrincipals;
    const currentEditPrincipalStatus: EditStatus = 'Pristine';
    return { currentEditPrincipal, currentEditPrincipalStatus, filteredPrincipals }
}

const newPrincipalSaved = (global: IGlobalState, dispatch: Dispatch, temporaryId: number, principal: Principal) => {
    // Questo reducer viene chiamato quando è stato salvato un'applicazione nuova
    const currentEditPrincipal = { principal: principal, modified: false, mode: InEditingMode.Edit };
    const currentEditPrincipalStatus: EditStatus = 'Pristine';
    const filteredPrincipals = [...global.filteredPrincipals, principal]
    return { currentEditPrincipal, currentEditPrincipalStatus, filteredPrincipals }
}

const removeInEditPrincipal = (global: IGlobalState, dispatch: Dispatch, id: number) => {
    // Dobbiamo spazzare via l'utente da tutte le liste e da currentUser
    const principals = global.principals.filter(u => u.Id !== id)
    const filteredPrincipals = global.filteredPrincipals.filter(u => u.Id !== id)
    if (global.currentEditPrincipal && global.currentEditPrincipal.principal.Id === id) {
        return { principals, filteredPrincipals, currentEditPrincipal: null }
    }
    return { principals, filteredPrincipals }
}

// WahtsNew
const setCurrentEditWhatsNewAndMode = (global: IGlobalState, dispatch: Dispatch, whatsNew: WhatsNew, mode: EditStatus) => {
    const currentEditWhatsNew = { whatsNew, modified: false, mode: InEditingMode.Edit };
    const currentEditWhatsNewStatus = mode;
    return { currentEditWhatsNew, currentEditWhatsNewStatus }
}

const createNewWhatsNew = (global: IGlobalState, dispatch: Dispatch, newOid: number) => {
    console.log('Aggiungo whats new nel reducers di Reactn');
    const whatsNew: WhatsNew = WhatsNew.newItem();
    const currentEditWhatsNew = { whatsNew, modified: true, mode: InEditingMode.New };
    const newWhatsNewOid = whatsNew.Id;
    return { currentEditWhatsNew, newWhatsNewOid }
}

const whatsNewSaved = (global: IGlobalState, dispatch: Dispatch, whatsNew: WhatsNew) => {
    console.log('sono in whatsNew Saved');
    const currentEditWhatsNew = {whatsNew: whatsNew, modified: false, mode: InEditingMode.Edit }
    const c = global.filteredWhatsNews.find(x => x.Id === whatsNew.Id)
    if (c) {
        c.Version = whatsNew.Version
        c.HtmlContent = whatsNew.HtmlContent
        c.ExpirationDate = whatsNew.ExpirationDate
        c.Title = whatsNew.Title;
    }    
    const filteredWhatsNews = global.filteredWhatsNews;
    const currentEditWhatsNewStatus: EditStatus = 'Pristine';
    return { currentEditWhatsNew, currentEditWhatsNewStatus, filteredWhatsNews }
}

const newWhatsNewSaved = (global: IGlobalState, dispatch: Dispatch, temporaryId: number, whatsNew: WhatsNew) => {
    // Questo reducer viene chiamato quando è stato salvato un'applicazione nuova
    const currentEditWhatsNew = { whatsNew: whatsNew, modified: false, mode: InEditingMode.Edit };
    const currentEditWhatsNewStatus: EditStatus = 'Pristine';
    const filteredWhatsNews = [...global.filteredWhatsNews, whatsNew]
    return { currentEditWhatsNew, currentEditWhatsNewStatus, filteredWhatsNews }
}

const removeInEditWhatsNew = (global: IGlobalState, dispatch: Dispatch, id: number) => {
    // Dobbiamo spazzare via l'utente da tutte le liste e da currentUser
    const whatsNews = global.whatsNews.filter(u => u.Id !== id)
    const filteredWhatsNews = global.filteredWhatsNews.filter(u => u.Id !== id)
    if (global.currentEditWhatsNew && global.currentEditWhatsNew.whatsNew.Id === id) {
        return { whatsNews, filteredWhatsNews, currentEditWhatsNew: null }
    }
    return { whatsNews, filteredWhatsNews }
}

const whatsNewClosed = (global: IGlobalState, dispatch: Dispatch, whatsNew: WhatsNew) => {
    console.log('sono in whatsNew Saved');
    // const currentEditWhatsNew = {whatsNew: whatsNew, modified: false, mode: InEditingMode.Edit }
    const c = global.filteredWhatsNews.find(x => x.Id === whatsNew.Id)
    if (c) {
        c.Version = whatsNew.Version
        c.HtmlContent = whatsNew.HtmlContent
        c.ExpirationDate = whatsNew.ExpirationDate
        c.Title = whatsNew.Title;
    }    
    const filteredWhatsNews = global.filteredWhatsNews;
    return { filteredWhatsNews }
}

export const addReducers = () => {
    // Company
    addReducer('setCurrentEditCompanyAndMode', setCurrentEditCompanyAndMode);
    addReducer('createNewCompany', createNewCompany);
    addReducer('newCompanySaved', newCompanySaved);
    addReducer('companySaved', companySaved);
    addReducer('removeInEditCompany', removeInEditCompany);
    // Agency
    addReducer('setCurrentEditAgencyAndMode', setCurrentEditAgencyAndMode);
    addReducer('createNewAgency', createNewAgency);
    addReducer('newAgencySaved', newAgencySaved);
    addReducer('agencySaved', agencySaved);
    addReducer('removeInEditAgency', removeInEditAgency);
    // Principal
    addReducer('setCurrentEditPrincipalAndMode', setCurrentEditPrincipalAndMode);
    addReducer('createNewPrincipal', createNewPrincipal);
    addReducer('principalSaved', principalSaved);
    addReducer('newPrincipalSaved', newPrincipalSaved);
    addReducer('removeInEditPrincipal', removeInEditPrincipal);
    // Whatsnew
    addReducer('setCurrentEditWhatsNewAndMode', setCurrentEditWhatsNewAndMode);
    addReducer('createNewWhatsNew', createNewWhatsNew);
    addReducer('whatsNewSaved', whatsNewSaved);
    addReducer('newWhatsNewSaved', newWhatsNewSaved);
    addReducer('removeInEditWhatsNew', removeInEditWhatsNew);
    addReducer('whatsNewClosed', whatsNewClosed);
}